import React, { Component } from 'react';
import { team_stats } from '~/tools/mll/headers';
import SocialHandle from '~/components/SocialHandles';
import './TeamBanner.css';

class TeamBanner extends Component {
  state = {
    current: {}
  }

  componentDidMount = () => {
    const teams = this.props.data.seasonData.standings.team;
    const current = teams.filter(el => el.teamid === this.props.teamId)[0];
    this.setState({
      current
    });
  }


  render() {
    const { twitterUrl, facebookUrl, instagramUrl } = this.props.social;
    return (
      <div className='teambanner-container'>
        <div className='teambanner-banner'>
          <div className='teambanner-wrapper'>
            <div className='teambanner-logo'>
              <img src={this.props.logo} alt='logo' />
            </div>
            <div className='teambanner-stats'>
              <div className='current-stats site-color'>
                {`${this.state.current.wins} - ${this.state.current.losses}`}
              </div>
              <div className='social-handles'>
                <SocialHandle url={twitterUrl} icon={"ion-social-twitter"}/>
                <SocialHandle url={facebookUrl} icon={"ion-social-facebook"}/>
                <SocialHandle url={instagramUrl} icon={"ion-social-instagram"}/>
              </div>
            </div>
            <table className='teambanner-table'>
              <tbody>
                {team_stats.map((headers, i) => (
                  <tr key={i}>
                    {headers.map((item, ii) => (
                      i === 0 ? 
                      <th key={ii}>{item}</th> : 
                      <td key={ii}>
                        {i === 2? item : this.state.current[item]}
                      </td>                                        
                    ))}
                  </tr>
                ))}
              </tbody>
            </table> 
          </div>
        </div>
      </div>
    )
  }
}

export default TeamBanner;